import React, {useContext, useEffect} from "react";
import {CancellationProcessContext} from "./CancellationProcess.component";
import MoneyHelper from "../../../services/MoneyHelper";
import InputGroup from "../../forms/components/InputGroup/InputGroup";
import {withNamespaces} from "react-i18next";
import CancellationOfferService from "../services/CancellationOfferService";
import {AuthContext} from "../../member/components/AuthContext";
import Select from "react-select";
import {PaymentTypes} from "../../clubs/models/Plan";

const UpgradeComponent = (props) => {
  const {t} = props;
  const upgradeData = props.data.upgrade || {};
  const {cancelDetails, plans} = useContext(CancellationProcessContext);
  const {member} = useContext(AuthContext);

  const plansToUpgrade = (cancelDetails.upgrade.plans || []).map(plan => (
    { id: plan.name, label: t(plan.name) }
  ));
  const monthsFree = cancelDetails.upgrade.number_of_months;
  const discount = cancelDetails.upgrade.discount;
  const selectedPlan = upgradeData.plan ? plansToUpgrade.find(p => p.id === upgradeData.plan) : plansToUpgrade[0];

  console.log('Test', plansToUpgrade, monthsFree);

  useEffect(() => {
    if (!upgradeData.plan) {
      changeData('plan', plansToUpgrade[0].id);
    }
  }, []);

  const changeData = (key, value) => {
    console.log('set data', key, value, props.data);
    props.setData({upgrade: {...upgradeData, [key]: value}});
  }

  const getFullPrice = () => {
    const plan = plans.find(p => p.category === selectedPlan.id);
    const price = plan.mms_prices.find(m => m.payment_type === PaymentTypes.Monthly);
    return price.base_price;
  };

  const getDiscountedPrice = () => {
    return CancellationOfferService.getDiscountedPrice(getFullPrice(), discount);
  }

  const getDiscountPeriod = () => {
    const paidUntil = new Date(member.plan_info.nextDueDate);
    const discountTo = CancellationOfferService.getDiscountEnd(paidUntil, monthsFree);
    return `${paidUntil.toLocaleDateString("en-us", {month: 'long', day: 'numeric', year: "numeric"})} - ${discountTo.toLocaleDateString("en-us", {month: 'long', day: 'numeric', year: "numeric"})}`;
  };

  const getFullRateStart = () => {
    const discountTo = CancellationOfferService.getDiscountEnd(member.plan_info.nextDueDate, monthsFree);
    discountTo.setDate(discountTo.getDate() + 1);
    return discountTo.toLocaleDateString("en-us", {month: 'long', day: 'numeric', year: "numeric"});
  };

  const getTotalSavings = () => {
    const discountedPrice = getDiscountedPrice();
    const currentPrice = getFullPrice();

    return CancellationOfferService.getSavings(currentPrice, discountedPrice, monthsFree);
  }

  return (
    <div className="cancellation-offer-component">
      <p>{t('member_cancellation_upgrade_description')}</p>
      <h3>{t('member_cancellation_upgrade_header')}</h3>

      <div className='form-group'>
        <InputGroup id="state"
                    className={"form-select"}
                    topLabel={true}
                    label={t('member_cancellation_upgrade_plan_select')}>
          <Select
            id="new_plan"
            name="new_plan"
            className={"form-select"}
            classNamePrefix={"form-select"}
            options={
              plansToUpgrade
            }
            placeholder={t(`member_cancellation_upgrade_plan_select`)}
            value={selectedPlan}
            onChange={(e) => {console.log('select plan', e); changeData('plan', e.id) }}
          />
        </InputGroup>
      </div>

      <div className="cancellation-offer-info-block">
        {[
          {
            text: t('member_cancellation_upgrade_current_price'),
            value: t('member_cancellation_upgrade_month_price', {
              price: MoneyHelper.toPrice(member.plan_info.nextDue),
              plan: member.membership_type
            })
          },
          {
            text: t('member_cancellation_upgrade_new_rate'),
            value: t('member_cancellation_upgrade_month_price', {
              price: MoneyHelper.toPrice(getDiscountedPrice()),
              discountPeriod: getDiscountPeriod()
            }),
            isRedValue: true
          },
          {
            text: t('member_cancellation_upgrade_full_rate'),
            value: t('member_cancellation_upgrade_full_price', {
              price: MoneyHelper.toPrice(getFullPrice()),
              startDate: getFullRateStart(),
            })
          },
          {
            text: t('member_cancellation_upgrade_total_savings'),
            value: MoneyHelper.toPrice(getTotalSavings())
          },
        ].map((item, index) => (
          <div key={index}>
            <div className='cancellation-offer-label'>{item.text}</div>
            <div className={`cancellation-offer-value ${item.isRedValue ? 'red-text' : ''}`}>{item.value}</div>
          </div>
        ))}
      </div>

      <div className='form-group'>
        <InputGroup id={'cancellation-offer-comment'} label={t('member_cancellation_upgrade_comment_label')} topLabel={true}>
          <input placeholder={t('member_cancellation_upgrade_comment_label')} type="text"
                 value={upgradeData.comment || ''} onChange={e => changeData('comment', e.target.value)}/>
        </InputGroup>
      </div>

      <p className='light light-grey'>{t('member_cancellation_upgrade_footnote')}</p>
    </div>
  );
};

export default withNamespaces()(UpgradeComponent);